/* ══════════════════════════════════════════════════════════════════════
   MONTAGE · Zweite Kopfzeile auf Hover oeffnen
   ══════════════════════════════════════════════════════════════════════
   Gleiches Verhalten wie `montage-menue-hover.js` fuer die Hauptzeile, nur
   fuer die Leiste aus `sections/mt-zweitmenue.liquid`. Eine eigene Datei,
   weil jenes Skript an Dawns <header-menu> haengt und die Leiste bewusst
   ein <details-disclosure> ist (Begruendung im Kopf der Section).

   Nur mit Maus (`hover: hover`, `pointer: fine`), nur ab 990 px. Klick und
   Tastatur bleiben Dawns <details-disclosure>. Ein Mausklick auf ein per
   Hover geoeffnetes Menue wird geschluckt, sonst klappt es wieder zu.
   ══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var medien = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  var VERZOEGERUNG = 160; // ms Nachlauf beim Verlassen
  var timer = null;

  function gruppen() {
    return document.querySelectorAll('.mt-zweitmenue__gruppe');
  }

  function setzen(gruppe, offen) {
    var details = gruppe.querySelector('details');
    if (details && details.open !== offen) details.open = offen;
  }

  function verdrahten() {
    gruppen().forEach(function (gruppe) {
      if (gruppe.dataset.mtHover === 'an') return;
      gruppe.dataset.mtHover = 'an';

      gruppe.addEventListener('mouseenter', function () {
        if (!medien.matches) return;
        window.clearTimeout(timer);
        gruppen().forEach(function (andere) {
          setzen(andere, andere === gruppe);
        });
      });

      gruppe.addEventListener('mouseleave', function () {
        if (!medien.matches) return;
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          setzen(gruppe, false);
        }, VERZOEGERUNG);
      });

      var summary = gruppe.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function (event) {
          if (!medien.matches || event.detail === 0) return;
          var details = summary.closest('details');
          if (details && details.open) event.preventDefault();
        });
      }
    });
  }

  if (medien.addEventListener) {
    medien.addEventListener('change', function () {
      if (!medien.matches) gruppen().forEach(function (g) { setzen(g, false); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', verdrahten);
  } else {
    verdrahten();
  }
  document.addEventListener('shopify:section:load', verdrahten);
})();
